<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="4">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>From</b-input-group-text>
            </b-input-group-prepend>
            <datepicker
              @dp-change="changeFromDate"
              :value="seminar.seminar_filter_from"
              :config="options"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>To</b-input-group-text>
            </b-input-group-prepend>
            <datepicker
              @dp-change="changeToDate"
              :value="seminar.seminar_filter_to"
              :config="options"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col v-show="seminar.is_seminars_loading" sm="4" class="localBold mt-1"
        ><i class="fa fa-refresh fa-spin localBold mr-2"></i>Synching</b-col
      >
    </b-row>
    <b-row>
      <b-col lg="8">
        <!-- <b-form-input
          size="sm"
          class="mr-sm-2"
          type="text"
          placeholder="Search"
          @keyup="filterList"
          v-model="searchString"
        />-->
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="globals.default_search_string"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col lg="4">
        <div class="form-group form-actions float-left pb-2">
          <b-button
            class="mr-2 btn"
            variant="success"
            type="submit"
            size="md"
            @click="newEntity"
          >
            <i class="fa fa-handshake-o"></i>
            New Seminar
          </b-button>
        </div>
        <div>
          <StyledDialog
            @filterList="filterList"
            :CurrentObject="mySelected"
            EntityType="Seminar"
          >
            <div slot="header">
              <h5>Seminar ID: {{ mySelected.SeminarID }}</h5>
              <h3>{{ mySelected.TerritoryName }}</h3>
              <!-- <h2>at {{mySelected.Restaurant.Name}}</h2> -->
              <!-- <h2>{{mySelected.Territory.TerritoryName}}</h2>
              <h4>{{mySelected.Restaurant.Name}}</h4>-->
              <!-- <h4>{{mySelected.Seatings[0].DateOfSeating}}</h4> -->
            </div>
            <div slot="details">
              <div></div>
            </div>
            <span slot="entityType">Seminar</span>
          </StyledDialog>
        </div>
      </b-col>
    </b-row>

    <b-row></b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredObjects"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
import moment from "moment";
import datepicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

export default {
  name: "Seminars",
  data: () => {
    return {
      fields: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;"
        },
        {
          key: "SeminarID",
          label: "ID",
          sortable: true,
          thStyle: "width: 5%;"
        },
        {
          key: "TerritoryName",
          label: "Territory",
          sortable: true
        },
        {
          key: "AccountManager",
          label: "Account Manager",
          sortable: true
        },
        {
          key: "SeminarDates",
          label: "Seminar Date(s)",
          sortable: true
        },
        {
          key: "Restaurants",
          label: "Restaurant(s)",
          sortable: true
        },
        {
          key: "EventType",
          label: "Type",
          sortable: true,
          thStyle: "width: 10%;"
        }
      ],
      mySelected: { Territory: {}, Owner: {}, Restaurant: {} },
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      searchString: "",
      options: {
        format: "MM/DD/YYYY",
        useCurrent: false
      }
    };
  },
  components: {
    cTable,
    //DeleteDialog,
    StyledDialog,
    datepicker
  },
  created() {
    if (!this.$store.state.globals.default_pp) {
      this.$store.dispatch(
        "globals/setDefaultPP",
        this.$store.state.n_user.n_current_user.UserProfileID
      );
    }

    this.$store.dispatch("seminar/fetchRestaurants");

    if (!this.$store.state.seminar.default_dates_overwritten) {
      var t = new Date();
      var fd = new Date(t.getFullYear(), t.getMonth(), 1);
      var ld = new Date(t.getFullYear(), t.getMonth() + 2, 0, 23, 59, 59);
      this.$store.dispatch("seminar/setFromDate", fd);
      this.$store.dispatch("seminar/setToDate", ld);
    }
    //this.$store.dispatch("seminar/fetchMailerTypes").then();
    if (this.$store.state.territory.territories.length === 0) {
      this.$store.dispatch("territory/fetchTerritories");
    }

    this.$store.dispatch("lpfilter/fetchFilterParams");
    this.$store.dispatch("lpfilter/fetchLPFiltersGlobal");

    if (this.$store.state.seminar.vendors.length === 0) {
      this.$store.dispatch("seminar/fetchVendors");
    }

    if (this.$store.state.seminar.contacts.length === 0) {
      this.$store.dispatch("seminar/fetchContacts");
    }

    if (this.$store.state.seminar.territory_contacts.length === 0) {
      this.$store.dispatch("seminar/fetchTerritoryContacts");
    }

    //if (this.$store.state.seminar.artwork_types.length === 0)
    //{
    this.$store.dispatch("seminar/fetchArtworkTypes");
    //}
    this.$store.dispatch("n_user/fetchUsers");
    this.$store.dispatch("seminar/fetchEventTypes");
    this.$store.dispatch("seminar/fetchCuisines");
    this.$store.dispatch("seminar/fetchSeminarTypes");
    this.$store.dispatch("seminar/fetchIncomeFilters");
    this.$store.dispatch("seminar/fetchDwellingFilters");

    this.refreshList();

    //     if (this.$store.state.seminar.seminars.length === 0)
    // {
    //    this.$store.dispatch("seminar/fetchSeminars");
    // }

    //     //this.filteredCampaigns = this.$store.state.campaign.campaigns;
    //     this.filterList();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.seminar.seminars.length;
      //return 4;
    },
    totalObjects: function() {
      return this.$store.state.seminar.seminars;
      //return 4;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["seminar", "globals", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  updated() {
    this.incrementCount;
  },
  watch: {
    totalObjects(newValue, oldValue) {},
    "$store.state.seminar.seminar_filter_from": function(newValue, oldValue) {
      this.refreshList();
    },
    "$store.state.seminar.seminar_filter_to": function(newValue, oldValue) {
      this.refreshList();
    }
  },
  methods: {
    async refreshList() {
      var _op = {
        FromDate: this.$store.state.seminar.seminar_filter_from,
        ToDate: this.$store.state.seminar.seminar_filter_to,
        UserProfileID: this.$store.state.n_user.n_current_user.UserProfileID
      };
      await this.$store.dispatch("seminar/fetchSeminarsByDate", _op);
      this.filterList();
    },
    changeFromDate: function(event) {
      this.$store.dispatch("seminar/setFromDate", event.target.value);
      this.$store.state.seminar.default_dates_overwritten = true;
    },
    changeToDate: function(event) {
      this.$store.dispatch("seminar/setToDate", event.target.value);
      this.$store.state.seminar.default_dates_overwritten = true;
    },
    filterList: function() {
      this.filteredObjects = this.$store.state.seminar.seminars.filter(
        seminar =>
          seminar.TerritoryName.toLowerCase().indexOf(
            this.$store.state.globals.default_search_string.toLowerCase()
          ) > -1 ||
          seminar.Restaurants.toLowerCase().indexOf(
            this.$store.state.globals.default_search_string.toLowerCase()
          ) > -1 ||
          seminar.AccountManager.toLowerCase().indexOf(
            this.$store.state.globals.default_search_string.toLowerCase()
          ) > -1 ||
          seminar.EventType.toLowerCase().indexOf(
            this.$store.state.globals.default_search_string.toLowerCase()
          ) > -1
      );
    },
    resetSearch: function() {
      this.$store.state.globals.default_search_string = "";
      this.filterList();
    },
    incrementCount() {
      this.$store.commit("INCREMENT_COUNT");
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    myRowClickHandler(record, index) {
      this.$store
        .dispatch("seminar/loadSeminarEdit", record.SeminarID)
        .then(() => {
          this.$router.push({ name: "Seminar" });
        });
    },
    newEntity() {
      this.$store
        .dispatch("seminar/newSeminar", this.createFreshObject())
        .then(() => {
          this.$router.push({ name: "Seminar" });
          //,
          //params: { id: this.event.id }
        })
        .catch(() => {
          console.log("There was a problem");
          //.dispatch('notification/add', this.event)
        });
    },
    deleteUser() {
      //this.$store.dispatch("n_user/createUser", this.createFreshUserObject());
    },
    createFreshObject() {
      return {
        SeminarID: -1,
        Territory: {
          Rotations: []
        },
        EventTypeID: -1,
        Artwork1ID: -1,
        VendorID: -1,
        IsSplit: false,
        UserProfileID: this.$store.state.n_user.n_current_user.UserProfileID,
        Seatings: [],
        Filters: [],
        Vendor: this.$store.state.seminar.vendors.find(
          vendor => vendor.VendorID === -1
        ),
        Owner: this.$store.state.n_user.n_users.find(
          n_user =>
            n_user.UserProfileID ===
            this.$store.state.n_user.n_current_user.UserProfileID
        ),
        Artwork1: this.$store.state.seminar.event_types.find(
          event => event.EventTypeID === -1
        ),
        EventType: this.$store.state.seminar.artwork_types.find(
          artwork => artwork.ArtworkID === -1
        ),
        Tracker: {
          CountRequestNA: true,
          SecureZipsNA: true,
          CountApprovalNA: true,
          UpdateTMNA: true,
          PlacedOrderVendorNA: true,
          PlacedNoteNA: true,
          EmailMarketerNA: true,
          AddedToPPTNA: true,
          CountRequestNAddedToMapNA: true,
          PlacedOrderProducerNA: true,
          AddedToTSNA: true,
          NewProducerPercNA: true,
          MailLandedNA: true
        }
      };
    },
    GetEarliestMailDate() {
      switch (moment().day()) {
        // If it is Monday (1),Saturday(6), or Sunday (0), Get the previous Friday (5)
        // and ensure we are on the previous week
        case 0:
          return moment().add(5, "days");
        case 1:
          return moment().add(4, "days");
        case 2:
          return moment().add(10, "days");
        case 3:
          return moment().add(9, "days");
        case 4:
          return moment().add(8, "days");
        case 5:
          return moment().add(7, "days");
        case 6:
          return moment().add(6, "days");
        default:
          return moment().add(3, "days");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
